import { render } from "./ConversationWithExperts.vue?vue&type=template&id=984dfbf6&scoped=true"
import script from "./ConversationWithExperts.vue?vue&type=script&lang=js"
export * from "./ConversationWithExperts.vue?vue&type=script&lang=js"

import "./ConversationWithExperts.vue?vue&type=style&index=0&id=984dfbf6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-984dfbf6"

export default script